import React from "react";
import * as constants from '../constants';
import { PROGRAM_FILTERS_VIEWS, PROGRAM_FILTERS_HIDE } from "../../../PagesSettings/pages/ProgramsConstructorPage/constants";
import ScheduleSettingViews from "../ScheduleSettingViews";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingSelect from "../../../../UI/Settings/CPSettingSelect";
import WidgetLanguageSetting, { LANGUAGE } from "../../components/Settings/WidgetLanguageSetting";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

const CommonSettings = ({ settings, onChange }) => {
    return (
        <>
            <CPSettingSize
                name={constants.FONT_SIZE_GENERAL}
                label="Общий размер шрифта"
                eventValue={settings?.[constants.FONT_SIZE_GENERAL]}
                defaultValue={'14px'}
                onChange={onChange}
            />
            <WidgetLanguageSetting
                lang={settings?.[LANGUAGE]}
                onUpdate={(key, value) => onChange({ [key]: value })}
            />
            <ScheduleSettingViews
                widgetViews={settings?.[constants.PROGRAM_VIEWS]}
                onChange={onChange}
            />
            <CPSettingSelect
                label="Отображение дней"
                property={constants.SCHEDULE_DAYS_VIEW}
                eventValue={settings?.[constants.SCHEDULE_DAYS_VIEW]}
                defaultValue="tabs"
                list={PROGRAM_FILTERS_VIEWS}
                localeKey="program.view"
                onChange={onChange}
            />
            <CPSettingSelect
                label="Отображение залов"
                property={constants.SCHEDULE_HALLS_VIEW}
                eventValue={settings?.[constants.SCHEDULE_HALLS_VIEW]}
                defaultValue="tabs"
                list={{...PROGRAM_FILTERS_VIEWS, PROGRAM_FILTERS_HIDE: PROGRAM_FILTERS_HIDE}}
                localeKey="program.view"
                onChange={onChange}
            />
            <hr />
            <CPSettingToggle
                name={constants.SCHEDULE_COMMON_SHOW_MODALS}
                isChecked={settings?.[constants.SCHEDULE_COMMON_SHOW_MODALS]}
                label="Включить отображение модальных окон"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_COMMON_ADD_TO_CALENDAR}
                isChecked={settings?.[constants.SCHEDULE_COMMON_ADD_TO_CALENDAR]}
                label="Показывать кнопку Добавить в календарь"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_SEARCH}
                isChecked={settings?.[constants.SCHEDULE_SHOW_SEARCH]}
                label="Показывать поиск"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_FORMAT_FILTER}
                isChecked={settings?.[constants.SCHEDULE_SHOW_FORMAT_FILTER]}
                label="Показывать фильтр по формату"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_TAGS_FILTER}
                isChecked={settings?.[constants.SCHEDULE_SHOW_TAGS_FILTER]}
                label="Показывать фильтр по тегам"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_PDF_EXPORT}
                isChecked={settings?.[constants.SCHEDULE_SHOW_PDF_EXPORT]}
                label="Показать кнопку Скачать PDF"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_DISPLAY_EPISODE_RECORD}
                isChecked={settings?.[constants.SCHEDULE_DISPLAY_EPISODE_RECORD]}
                label="Включить отображение записи у прошедших эпизодов"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_WATCH_RECORDING}
                isChecked={settings?.[constants.SCHEDULE_SHOW_WATCH_RECORDING]}
                label="Показывать кнопку Смотреть запись"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_SHOW_ASK_QUESTION}
                isChecked={settings?.[constants.SCHEDULE_SHOW_ASK_QUESTION]}
                label="Показывать кнопку Задать вопрос"
                onChange={onChange}
            />
        </>
    );
};

export default CommonSettings;
